module.exports = __webpack_public_path__ + "img/avatar14_11zon.5212f521.webp";